import styled, { keyframes } from 'styled-components'
import { HEADER_HEIGHT } from '../Header/styles'

const slideDown = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

export const BannerContainer = styled.div`
  animation: ${slideDown} 0.3s ease-out;
  background-color: var(--trueye-dark-grey, #272727);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  border-left: 4px solid #4caf50;
  box-sizing: border-box;
  color: #ffffff;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  left: 0;
  padding: 12px 16px;
  position: fixed;
  right: 0;
  top: ${HEADER_HEIGHT}px;
  width: 100%;
  z-index: 100;
`

export const BannerIcon = styled.span`
  font-size: 22px;
  flex-shrink: 0;
  line-height: 1;
  margin-top: 1px;
`

export const BannerBody = styled.div`
  flex: 1;
  min-width: 0;
`

export const BannerTitle = styled.p`
  margin: 0 0 2px;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
`

export const BannerMessage = styled.p`
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.4;
`

export const DismissButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  padding: 4px 6px;
  flex-shrink: 0;
  margin-top: -2px;

  &:hover {
    background: rgba(255, 255, 255, 0.18);
    color: #ffffff;
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.4);
    border-radius: 4px;
  }
`
